export function applyGlobalSeo({ siteName, keywords, description, siteLogo } = {}) {
  if (siteName) {
    document.title = siteName;
  }

  setMetaTag('keywords', keywords || '');
  setMetaTag('description', description || '');
  if (siteLogo) {
    setFavicon(siteLogo);
  }
}

export function setDocumentTitleWithSite(pageTitle, siteName) {
  if (pageTitle && siteName) {
    document.title = `${pageTitle} - ${siteName}`;
  } else if (pageTitle) {
    document.title = pageTitle;
  } else if (siteName) {
    document.title = siteName;
  }
}

// Page-level SEO override (e.g., project detail)
export function applyPageSeo({ title, keywords, description } = {}) {
  if (title) {
    document.title = title;
  }
  if (typeof keywords !== 'undefined') {
    setMetaTag('keywords', keywords || '');
  }
  if (typeof description !== 'undefined') {
    setMetaTag('description', description || '');
  }
}

function setMetaTag(name, content) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content || '');
}

function setFavicon(href) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'icon');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}


